import Utils from 'src/utils/Utils';
import {LEFT, RIGHT} from './constants';

const CLASS_RIBBON = 'ribbon-items';
const WRAPPER_RIBBON = 'vcardMatch_ribbons-players';
const CLASS_FOCUSABLE = 'focusable';


const getIdPlayer = (targetId: string) => {
    const splitId = targetId.split('-');
    return splitId && splitId.length >= 2 ? splitId[1] : null;
};

const getIndexPlayer = (visible: any[], id: string | null, direction: string) => {
    const index = visible.findIndex((node: { item: { id: any } }) => node.item.id === id);
    return direction === LEFT ? index - 1 : index + 1;
};

const getIndexBefore = (index: number, direction: string) => {
    return direction === LEFT ? index + 1 : index - 1;
};

const transformData = (data: any, index: number, indexBefore: number) => {
    data[indexBefore] = { ...data[indexBefore], nodeFocusable: false };
    data[index] = { ...data[index], nodeFocusable: true };
};

const scrollRibbon = (direction: string, data: any[], index: number) => {
    const elementScroll = document.getElementsByClassName(CLASS_RIBBON);
    const increment = direction === LEFT ? 0 : 200;
    const indexElementScroll = data[index].item.typeTeam === 'away' ? 1 : 0;
    if (elementScroll && elementScroll.length > 0)
        elementScroll[indexElementScroll].scrollLeft = increment;
};

const focusCardPlayer = (id: string | null, data: any[], index: number) => {
    const playerToFocus = `#link-${id}-${data[index].item.typeTeam}`;
    Utils.setInitialFocusChangeTime(playerToFocus, 0);
};

const getIdentifiers = (targetId: string, data: any[], direction: string) => {
    const id = getIdPlayer(targetId);
    const index = getIndexPlayer(data, id, direction);
    const indexBefore = getIndexBefore(index, direction);
    return { id, index, indexBefore };
};

const moveFocusInCardSoccerPlayer = (
    targetId: string,
    visible: any[],
    direction: string,
    indexTarget?: number,
    items?: any[]
) => {
    const { id, index, indexBefore } = getIdentifiers(targetId, visible, direction);

    if (index === -1 && direction === LEFT && indexTarget && items) {
        visible.pop();
        visible.unshift({ index: indexTarget, item: items[indexTarget] });
        return;
    }

    transformData(visible, index, indexBefore);
    scrollRibbon(direction, visible, index);
    focusCardPlayer(id, visible, index);
};

export const navigationLeftSoccer = (
    visible: any[] | { index: number; item: any }[],
    items: any[],
    event: { target: { id: string } }
) => {
    const indexTarget = visible[0].index === 0 ? 0 : visible[0].index - 1;
    const lastIndexItems = items[items.length - 1].index;
    const lastIndexVisible = visible[visible.length - 1].index;
    const targetId = event.target.id;
    const direction = LEFT;
    const { id } = getIdentifiers(targetId, visible, direction);
    const indexElement = id === items[0].id;

    if (lastIndexItems !== lastIndexVisible && !indexElement) {
        visible.pop();
        visible.unshift({ index: indexTarget, item: items[indexTarget] });
    } else {
        !indexElement &&
            moveFocusInCardSoccerPlayer(targetId, visible, direction, indexTarget, items);
    }
};

export const navigationRightSoccer = (visible: any[], items: any[], event: any) => {
    const last = visible[visible.length - 1];
    const targetId = event.target.id;
    const direction = RIGHT;
    const { index } = getIdentifiers(targetId, visible, direction);

    if (last.index !== items.length - 1) {
        const index = last.index + 1;
        visible.shift();
        visible.push({ index, item: items[index] });
    } else {
        index !== visible.length && moveFocusInCardSoccerPlayer(targetId, visible, direction);
    }
};

export const navigationDownSoccer = (e: any, index: number) => {
    e.preventDefault();
    e.stopPropagation();
    const elementScroll = document.getElementsByClassName(CLASS_RIBBON)
        ? document.getElementsByClassName(CLASS_RIBBON)[index]
        : null;
    const card =
        elementScroll && elementScroll.getElementsByClassName(CLASS_FOCUSABLE)
            ? elementScroll.getElementsByClassName(CLASS_FOCUSABLE)[0]
            : null;
    card && Utils.setInitialFocusChangeTime(`#${card.id}`, 0);
};
export const navigationUpSoccer = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    const elementScroll = document.getElementsByClassName(CLASS_RIBBON)
        ? document.getElementsByClassName(CLASS_RIBBON)[0]
        : null;
    const card =
        elementScroll && elementScroll.getElementsByClassName(CLASS_FOCUSABLE)
            ? elementScroll.getElementsByClassName(CLASS_FOCUSABLE)[0]
            : null;

    card && Utils.setInitialFocusChangeTime(`#${card.id}`, 0);
};



// WEBPACK FOOTER //
// ./src/components/RibbonNew/functions.mundial.ts